









import { Component, Prop, Mixins } from "vue-property-decorator";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

@Component({
  components: {
    "cprod-timeline": () =>
      import(`@/components/app/global/contractProducts/cProdTimeline.vue`)
  }
})
export default class CProdTimelineComponent extends Mixins(CProdInjectorMixin) {
  // Props
  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  // Computed

  public get isVisible() {
    if (!this.cProdData.isSubscription) return false;
    if (this.cProdData.isOnTerminatingTrial) return false;
    return true;
  }
}
